<template>
    <div class="payment-scheduler">
        <button class="payment-scheduler__button button--yellow"
                v-on:click="pay"
        >Погасить ежемесяный платеж</button>

        <h3 class="payment-scheduler__title">Календарь платежей</h3>

        <ul class="payment-scheduler__list">
            <template  v-for="item in sheduler">
                <p v-if="checkYear(item.year)" class="payment-scheduler__year-separator">{{item.year}}</p>

                <li class="payment-scheduler__item" v-bind:class="itemClass(item)">
                    <span class="payment-scheduler__month">{{getFormat(item.date, 'MMMM') | Capitalized}}</span>

                    <span v-if="isPaymentExpired(item)" class="payment-scheduler__center">ПРОСРОЧЕН</span>
                    <span v-else class="payment-scheduler__center">{{getFormat(item.date, 'DD')}}</span>

                    <span class="payment-scheduler__amount">{{item.amount | ceil | numberFormat}} ₸</span>
                </li>
            </template>
        </ul>
    </div>
</template>

<script>
    import moment from 'moment'
    import each from 'lodash/each'
    moment.locale('ru');
    export default {
        name: 'paymentSchedule',
        data(){
            return {
                sheduler: [],
                currentYear: 0,
            }
        },
        methods: {
            pay: function(){
                this.$modal.show('monthlyPayment', {
                    amountToPay: this.currentLoan.MonthlyPayment,
                    amountOfPayment : this.currentLoan.MonthlyPayment,
                    balance: this.currentLoan.balance
                });
            },
            isPaymentSettled: function (item) {
                return item.remainingDebtBySchedule === 0;
            },
            isPaymentExpired: function(item){
               return (item.order < this.currentPayment) && !this.isPaymentSettled(item);
            },
            getFormat: function (date, format = 'MMMM') {
                return date.format(format)
            },
            itemClass: function (item) {
                return {
                    'payment-scheduler__item--confirm': this.isPaymentSettled(item),
                    'payment-scheduler__item--expired': this.isPaymentExpired(item)
                }
            },
            checkYear: function ( year ) {
                if( this.currentYear !== year) {
                    this.currentYear = year;
                    return true;
                }
                return false;
            }
        },
        computed: {
            creditID: function () {
                return this.$store.getters['credit/getField']('creditID');
            },
            currentLoan: function () {
                return this.$store.getters['current/getCurrentLoan']
            },
            currentPayment: function () {
                return this.currentLoan.currentOrderPaymentSchedule;
            }

        },
        mounted(){
            let _this = this;

            this.$http.get('/json/credit/schedule', {params: {creditId: this.creditID}}).then(
                response => {
                    if(response.data.code === 0){
                        each(response.data.data, function (item, key) {
                           _this.sheduler.push({
                               date: moment(+item.date.year+'-'+item.date.monthValue+'-'+item.date.dayOfMonth),
                               year: item.date.year,
                               amount: item.amount,
                               remainingDebtBySchedule: item.remainingDebtBySchedule,
                               order: item.order
                           });
                        });
                    }else{
                        //TODO: Логгирование и что-то делание
                    }
                },
                response => {

                }
            )
        }
    }
</script>

<style lang="scss">
    @import "~@/assets/scss/variable";
    .cabinet-calculator .payment-scheduler{
        padding: 0 10px;
    }
    .payment-scheduler{
        padding: 0 0;
        &__button{
            max-width: 100%;
            width: 100%;
            font-size: 16px;
            color: #333333;
            margin: 0 0 10px;
            font-family: $RobotoRegular;
            padding: 10px 15px;
            border: none;
            border-radius: 25px;
        }
        &__title{
            font-size: 18px;
            color: #333333;
            font-family: $RobotoRegular;
            font-weight: normal;
            text-align: left;
            padding-left: 10px;
        }
        &__list{
            padding: 10px 10px 0;
            margin-bottom: 5px;
            margin-top: 5px;
            border-top: 2px solid #D7D7D7;
            list-style-type: none;
            display: flex;
            justify-content: flex-start;
            flex-wrap: wrap;
        }
        &__item{
            border: 1px solid #979797;
            border-radius: 5px;
            margin: 2px;
            padding: 5px;
            height: 92px;
            box-sizing: border-box;
            display: flex;
            flex-direction: column;
            justify-content: space-between;
            align-items: center;
            width: 100%;
            max-width: calc(33.33333% - 4px);
        }
        &__month{
            font-size: 12px;
            font-family: $RobotoRegular;
            color: #333333;
            text-align: center;
        }
        &__center{
            font-family: $RobotoRegular;
            font-size: 18px;
            text-align: center;
            color: #FFA600;
        }
        &__amount{
            font-family: $RobotoRegular;
            font-size: 16px;
            text-align: center;
            color: #333333;
        }
        &__year-separator{
            font-family: $RobotoMedium;
            font-size: 14px;
            color: #333333;
            text-align: left;

            border-bottom: 1px solid #D7D7D7;
            max-width: 100%;
            width: 100%;
            margin-bottom: 5px;
        }
    }
    .payment-scheduler{
        &__item--confirm{
            background: rgba(255,183,0,0.3);
            border: 1px solid rgba(255,183,0,0.3);

            .payment-scheduler__center{
                background: url('~@/assets/svg/components/check_white.svg') no-repeat center center #FFB700;
                background-size: 16px 16px;
                color: transparent;
                width: 24px;
                height: 24px;
                border-radius: 50%;
            }
        }

        &__item--expired{
            background: rgba(255,78,0,0.12);
            border: 1px solid #FF0000;

            .payment-scheduler__center{
                background-size: 16px 16px;
                font-size: 12px;
                color: #D0021B;
                font-family: $RobotoMedium;
                width: 100%;
                height: auto;
                border-radius: 50%;
            }
        }
    }
</style>